/**
 * Registers all built-in extension handlers with the global registry.
 *
 * Called from src/server/index.ts at startup before the server starts.
 */
import { extensionRegistry } from "@shared/core/index.ts"

import { AnnotationTimeHandler } from "./annotation-time/handler.ts"
import { ImageLabelHandler } from "./image-label/handler.ts"
import { LabelRasterHandler } from "./label-raster/handler.ts"
import { MaskHandler } from "./mask/handler.ts"
import { PiqualHandler } from "./piqual/handler.ts"
import { PiradsHandler } from "./pirads/handler.ts"
import { ScoreHandler } from "./score/handler.ts"
import { TextHandler } from "./text/handler.ts"
import { VectorHandler } from "./vector/handler.ts"
import { VoiceNoteHandler } from "./voice-note/handler.ts"

export function registerBuiltInExtensions(): void {
  extensionRegistry.register(new MaskHandler())
  extensionRegistry.register(new ScoreHandler())
  extensionRegistry.register(new PiqualHandler())
  extensionRegistry.register(new PiradsHandler())
  extensionRegistry.register(new VectorHandler())
  extensionRegistry.register(new ImageLabelHandler())
  extensionRegistry.register(new TextHandler())
  extensionRegistry.register(new AnnotationTimeHandler())
  extensionRegistry.register(new LabelRasterHandler())
  extensionRegistry.register(new VoiceNoteHandler())
}
